import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk'
import allReducers from './reducers';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__)
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : (f) => f

const store = createStore(
  allReducers,
  compose(
    applyMiddleware(thunk),
    composeEnhancers
  )
)

export default store